import axios from 'axios';

const API_BASE_URL = 'https://naoxvicvbnefghrluslj.supabase.co/rest/v1';
const API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5hb3h2aWN2Ym5lZmdocmx1c2xqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg0NDQ1NTcsImV4cCI6MjA2NDAyMDU1N30.8xjZ6OzQP-dWmERKxVWgr6_sLPkA52YrBFQ2uuSpgrY';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'apikey': API_KEY,
    },
});

export default api;
